module.exports = __webpack_public_path__ + "media/truth_initiative/truth-background-22430a30.jpg";